module.exports = __webpack_public_path__ + "static/curve-6002e3c0147573e5de253a4742af2134.png";